import React, {useEffect, useRef, useState} from "react";
import {MdArrowDropDown, MdArrowDropUp, MdBarChart, MdOutlineCalendarToday,} from "react-icons/md";
import Card from "components/card";
import LineChart from "components/charts/LineChart";
import MiniCalendar from "components/calendar/MiniCalendar";
import axios from "axios";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import moment from "moment/moment";

const DeletedUsersTrendGraph = () => {

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();

    let activatedDevicesCount, months
    let [resultSize, setResultSize] = useState(0)
    let[dateRange, setDateRange] = useState("This Month")
    let [momDevicesPercentage, setMomDevicesPercentage] = useState(0)
    const [presentMonthCount, setPresentMonthCount] = useState([]);
    let [refreshData, setRefreshData] = useState(true)
    let [selectedValue, setSelectedValue] = useState("Monthly")
    const [errorMessage, setErrorMessage] = useState("")
    let [dataCount, setDataCount] = useState([]);
    let [options, setOptions] = useState([]);
    const selectRef = useRef(null);

    const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate()
    const addMonths = (input, months) => {
        const date = new Date(input)
        date.setDate(1)
        date.setMonth(date.getMonth() + months)
        date.setDate(Math.min(input.getDate(), getDaysInMonth(date.getFullYear(), date.getMonth() + 1)))
        return date.toISOString().slice(0, 10)
    }

    function formatDateForApi(date) {
        var d = date.split("-");
        var y = d[0]
        var m = d[1]
        var da = d[2]
        date = da + "-" + m + "-" + y
        ////console.log(date)
        return date
    }

    const getDateOneMonthBefore = () => {
        const today = new Date();
        const oneMonthAgo = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());

        // Format the date in YYYY-MM-DD format
        const formattedDate = new Intl.DateTimeFormat('en-IN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            separator: '-'
        }).format(oneMonthAgo);

        return (formattedDate.replace("/", "-"))
    };

    let [LowerDate, setLowerDate] = useState(addMonths(new Date(new Date().toISOString().slice(0, 10)), -11));
    let [UpperDate, setUpperDate] = useState(new Date().toISOString().slice(0, 10))

    function handleStartDateChange(lowerDate){
        setLowerDate(lowerDate)
        sessionStorage.setItem("startDate", lowerDate)
    }

    function handleEndDateChange(upperDate){
        setUpperDate(upperDate)
        sessionStorage.setItem("endDate", upperDate)
    }

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    const handleIncreaseDate = (currentDate) => {
        const newDate = moment(currentDate, 'DD-MM-YYYY').add(1, 'days');
        currentDate = newDate.format('DD-MM-YYYY')
        //console.log("CURRENT DATE: ", currentDate)
        return currentDate
    };

    async function getDeletedUsersTrend(dateRangeFilter) {
        if ((accesscontrollevel.toString() === "1") || (accesscontrollevel.toString() === "3") || (accesscontrollevel.toString() === "4") || (accesscontrollevel.toString() === "5")) {
            var chartLabels = [];
            var count = [];
            var url = CROMPTON_ANALYTICS_URL + "v1/user/deletedAccount" + dateRangeFilter + "/" + formatDateForApi(LowerDate) + "/" + handleIncreaseDate(formatDateForApi(UpperDate))
            //console.log(dateRangeFilter)
            //console.log("URL: ", url)
            await axios({
                method: "GET", url: url, headers: {
                    Authorization: decryptedValue,
                }

            }).then((res) => {
                setErrorMessage("")
                setResultSize(res.data.length)
                resultSize = res.data.length
                localStorage.setItem("selectedValue", dateRangeFilter)

                if (dateRangeFilter === "Weekly") {
                    for (var i in res.data) {
                        if (i < (Object.keys(res.data).length - 1)) {
                            chartLabels.push((res.data[i].week).slice(6, 9))
                            count.push(res.data[i].accounts)
                        }
                    }
                    setDateRange("This Week")
                    //console.log("Weeks", chartLabels)
                    /*localStorage.setItem("deviceTrendsWeekly", JSON.stringify(chartLabels))
                    localStorage.setItem("activatedDevicesForLastOneYearWeekly", JSON.stringify(count))*/
                }
                if (dateRangeFilter === "Monthly") {
                    for (var i in res.data) {
                        if (i < (Object.keys(res.data).length - 1)) {
                            chartLabels.push((res.data[i].month).slice(0, 3))
                            count.push(res.data[i].accounts)
                        }
                    }
                    setDateRange("This Month")
                    /*localStorage.setItem("deviceTrendsMonths", JSON.stringify(chartLabels))
                    localStorage.setItem("activatedDevicesForLastOneYearMonthly", JSON.stringify(count))*/
                }

                setDataCount(count)
                dataCount = count
                setOptions(chartLabels)
                options = chartLabels

                setPresentMonthCount(count[resultSize - 2])
                if(isNaN(((count[resultSize- 2] - count[resultSize - 3]) / count[resultSize - 3]) * 100)){
                    setMomDevicesPercentage(0)
                }else{
                    setMomDevicesPercentage(((count[resultSize- 2] - count[resultSize - 3]) / count[resultSize - 3]) * 100)

                }

                if((count[resultSize - 3]) === 0){
                    setMomDevicesPercentage(100)
                }
                setRefreshData(false)

                /*console.log("Data labels: ", chartLabels)
                console.log("Data values: ", count)*/

            }).catch((error) => {
                setRefreshData(false)
                setErrorMessage(error.response.data.message)
                if (error.response.data.status === "401" || error.response.data.status === "403") {
                    handleLogOut();
                }
            })

        } else {
            //console.log("Inside stats non admin")
        }
    }


    useEffect(() => {
        if (selectRef.current) {
            selectRef.current.focus();
        }
        if((sessionStorage.getItem("startDate")) !== null){
            setLowerDate((sessionStorage.getItem("startDate")))
        }

        if((sessionStorage.getItem("endDate")) !== null){
            setUpperDate((sessionStorage.getItem("endDate")))
        }

        //console.log("REFRESH inside useeffect", refreshData)

        getDeletedUsersTrend(selectedValue)

        setRefreshData(true)

    }, [selectedValue, LowerDate, UpperDate])

    function handleChangeMonthDropDown() {
        const selectBox = document.getElementById("selectBoxInactive")
        selectedValue = selectBox.options[selectBox.selectedIndex].value
        setSelectedValue(selectBox.options[selectBox.selectedIndex].value)

        if(selectedValue === "weekly" || selectedValue === "Weekly"){
            getDeletedUsersTrend("Weekly")
        }
        if(selectedValue === "monthly" || selectedValue === "Monthly"){
            getDeletedUsersTrend("Monthly")
        }
        //getInActiveDevicesTrend(selectedValue.toLowerCase())
    }


    return (
        <Card extra="!p-[20px] text-center">
            <div className="flex justify-between">
                <h2 className="text-lg font-bold text-navy-700 dark:text-white">
                    Deleted Users Trend
                </h2>
                <div className="mb-6 flex items-center justify-center">
                    <select id="selectBoxInactive" onChange={handleChangeMonthDropDown}
                            className="mb-3 flex items-center justify-center
                            text-sm font-bold text-gray-600 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white" ref={selectRef}>
                        <option value="Weekly">Weekly</option>
                        <option value="Monthly" selected>Monthly</option>
                    </select>
                </div>
            </div>

            <div className="flex justify-between">
                <h2 className="text-lg font-bold text-red-700 dark:text-white">
                    {errorMessage}
                </h2>
            </div>

            <div className="flex justify-between">
                <button
                    className="linear mt-1 flex items-center justify-center gap-2 rounded-lg bg-lightPrimary p-2 text-gray-600 transition duration-200 hover:cursor-pointer hover:bg-gray-100 active:bg-gray-200 dark:bg-white dark:hover:opacity-90 dark:active:opacity-80">
                    <input type={"date"} id="startDate" className="datePicker" value={LowerDate}
                           onChange={(e) => handleStartDateChange(e.target.value)}/>
                    <input type={"date"} id="endDate" className="datePicker" value={UpperDate}
                           onChange={(e) => handleEndDateChange(e.target.value)}/>
                    {/*<span className="text-sm font-medium text-gray-600 react"></span>*/}
                </button>
            </div>

            <div
                className="flex h-full w-full flex-row justify-between sm:flex-wrap lg:flex-nowrap 2xl:overflow-hidden">
                <div className="flex flex-col">
                    <p className="mt-[20px] text-3xl font-bold text-navy-700 dark:text-white">
                        {presentMonthCount}
                    </p>
                    <div className="flex flex-col items-start">
                        <p className="mt-2 text-sm text-gray-600">{dateRange}</p>
                        <div className="flex flex-row items-center justify-center">
                            {momDevicesPercentage >= 0 ?
                                <div className="flex flex-row items-center justify-center">
                                    <MdArrowDropUp className="font-medium text-green-500"/>
                                    <p className="text-sm font-bold text-green-500"> {momDevicesPercentage.toFixed(0).replace("-", "")} % </p>
                                </div> :
                                <div className="flex flex-row items-center justify-center">
                                    <MdArrowDropDown className="font-medium text-red-500"/>
                                    <p className="text-sm font-bold text-red-500"> {momDevicesPercentage.toFixed(0).replace("-", "")} % </p>
                                </div>
                            }

                        </div>
                    </div>
                </div>
                <div className="h-[250px] w-full xl:h-[350px]">

                    {/*{selectedValue === "Monthly" ?
                        <LineChart
                            options={{
                                legend: {
                                    show: false,
                                },

                                theme: {
                                    mode: "light",
                                },
                                chart: {
                                    type: "line",

                                    toolbar: {
                                        show: true,
                                    },
                                },

                                dataLabels: {
                                    enabled: false,
                                },
                                stroke: {},

                                tooltip: {
                                    style: {
                                        fontSize: "12px",
                                        fontFamily: undefined,
                                        backgroundColor: "#000000"
                                    },
                                    theme: 'dark',
                                    x: {},
                                },
                                grid: {
                                    show: false,
                                },
                                xaxis: {
                                    categories: options,
                                    show: true,
                                    axisBorder: {
                                        show: true,
                                    },
                                    axisTicks: {
                                        show: true,
                                    },
                                    labels: {
                                        style: {
                                            colors: "#A3AED0",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                        },
                                    },
                                    type: "text",
                                    range: undefined,
                                },

                                yaxis: {
                                    show: true,
                                },
                            }}
                            series={[{
                                data: dataCount,
                                color: "#4318FF",
                            }]}
                        /> : selectedValue === "Weekly" ?
                            <LineChart
                                options={lineChartOptionsWeeklyTrendDevices}
                                series={lineChartActivatedDevicesDataWeekly}
                            /> : <LineChart
                                options={lineChartOptionsDailyTrendDevices}
                                series={lineChartActivatedDevicesDataDaily}
                            />
                    }*/}

                    <LineChart
                        options={{
                            legend: {
                                show: false,
                            },

                            theme: {
                                mode: "light",
                            },
                            chart: {
                                type: "line",

                                toolbar: {
                                    show: true,
                                },
                            },

                            dataLabels: {
                                enabled: false,
                            },
                            stroke: {},

                            tooltip: {
                                style: {
                                    fontSize: "12px",
                                    fontFamily: undefined,
                                    backgroundColor: "#000000"
                                },
                                theme: 'dark',
                                x: {},
                            },
                            grid: {
                                show: false,
                            },
                            xaxis: {
                                categories: options,
                                show: true,
                                axisBorder: {
                                    show: true,
                                },
                                axisTicks: {
                                    show: true,
                                },
                                labels: {
                                    style: {
                                        colors: "#A3AED0",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                    },
                                },
                                type: "text",
                                range: undefined,
                            },

                            yaxis: {
                                show: true,
                                color: "black",
                                labels: {
                                    show: true,
                                    style: {
                                        colors: "#CBD5E0",
                                        fontSize: "14px",
                                    },
                                },
                            },
                        }}
                        series={[{
                            name: "User Count",
                            data: dataCount,
                            color: "#0b83b5",
                        }]}
                    />

                </div>
                {/*<div id="monthlyData" className="h-[250px] w-full xl:h-[350px]" hidden={true}>
                    <LineChart
                        options={lineChartOptionsMonthlyData}
                        series={lineChartActivatedDevicesDataMonthly}
                    />
                </div>
                <div id="weeklyData" className="h-[250px] w-full xl:h-[350px]" hidden={true}>
                    <LineChart
                        options={lineChartOptionsWeeklyData}
                        series={lineChartActivatedDevicesDataWeekly}
                    />
                </div>
                <div id="dailyData" className="h-[250px] w-full xl:h-[350px]" hidden={true}>
                    <LineChart
                        options={lineChartOptionsDailyData}
                        series={lineChartActivatedDevicesDataDaily}
                    />
                </div>*/}
            </div>
        </Card>
    );
};

export default DeletedUsersTrendGraph;
